function readAutoCollapseMenu () {
  const raw = localStorage.getItem('autoCollapseMenu')
  if (raw === null) {
    return true
  }
  return raw === 'true'
}

export default {
  // 窗口可视大小
  clientHeight: document.body.clientHeight,
  clientWidth: document.body.clientWidth,
  // 加载遮罩
  loadingMain: 0,
  // 菜单折叠
  collapseMenu: false,
  // 点击菜单后自动折叠（持久化到 localStorage）
  autoCollapseMenu: readAutoCollapseMenu(),
}



// WEBPACK FOOTER //
// ./src/store/state.js